/**
 * Created by Ning Jiang on 9/21/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {IceIceYetiGameAssets} from "../IceIceYetiGameAssets";
import {IceIceYetiGameConfig} from "../IceIceYetiGameConfig";

export class IceIceYetiLogo extends BaseView {

    private _layer:ScalableLayer;
    private _logoContainer:PIXI.Container;

    private _minLogoHeight:number = 60;
    private _reelTopY:number;
    private _reelWidth:number;

    constructor() {
        super();
        this._layer = StageManager.getLayer(IceIceYetiGameConfig.instance.LAYERS.LOGO.name);
        this._reelTopY = GameConfig.instance.REEL_AREA_MASK_RECT != null ? GameConfig.instance.REEL_AREA_MASK_RECT.y : GameConfig.instance.REEL_AREA_POS_Y;
        this._reelWidth = GameConfig.instance.REEL_AREA_WIDTH;
    }

    protected initAnimations():void {
        this._logoContainer = new PIXI.Container();
        this._layer.addChild(this._logoContainer);

        const shadow = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.LOGO_SHADOW)[0]);
        shadow.anchor.set(0.5, 0.5);
        shadow.blendMode = PIXI.BLEND_MODES.MULTIPLY;
        shadow.position.y = 20;
        this._logoContainer.addChild(shadow);

        const logo = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.LOGO)[0]);
        logo.anchor.set(0.5, 0.5);
        logo.position.y = 10;
        this._logoContainer.addChild(logo);
    }

    protected onResize(resizeData:IResizeData):void {
        if(resizeData.orientation === Orientation.PORTRAIT) {
            const spaceHeight:number = (MathHelper.floorToDecimals(this._layer.y / this._layer.scale.y, 0) + this._reelTopY) - 20;
            if(spaceHeight < this._minLogoHeight) {
                this._logoContainer.visible = false;
                return;
            }

            Helper.fitItemInRectangle(this._logoContainer, new PIXI.Rectangle(
                -this._layer.x / this._layer.scale.x,
                -this._layer.y / this._layer.scale.y,
                this._reelWidth, spaceHeight
            ), 0.5);
            this._logoContainer.visible = true;
        } else {
            this._logoContainer.visible = false;
        }
    }
}